import React from "react";

import Section from "../Section/Section";
import TrustedByHospitals from "../TrustedByHospital/TrustedByHospitals";
import HospitalBackend from "../HospitalBacend/HospitalBackend";
import ReferPatient from "../ReferPAtient/ReferPatient";
import ServicesSnapshot from "../ServicesSnapShot/Services";
import ServiceGrid from "../pages/ServiceGrid.jsx"
import CareDeliver from "../CareDeliver/CaredEliver";
import Testimonials from "../Testimonial/Testimonial";
import CareCronicles from "../CareCronicles/CareCronicles";
import JoinMovement from "../JoinTheMovement/JoinMovement"; 
import MeetCarePreneur from "../MeetCarePreneur/MeetCarePreneur";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import {testimonialsData} from "../Testimonial/Testimonial.jsx"

const Home = () => {
  return (
    <>
      <Header />
      <Section />
      <MeetCarePreneur />
      {/* <CarePreneurVideos /> */}
      <TrustedByHospitals />
      <HospitalBackend />
      <ReferPatient />
      <ServicesSnapshot />
       <CareDeliver />
      {/* <Testimonials /> */}

      <Testimonials data={testimonialsData}
      title="What Our Champions Say!"
      subtitle="Testimonials:"
        textKey="desc"
        imgKey="userimg"
        nameKey="username"
        // settings={settings}
        className="physio-testimonials" />

      <CareCronicles />
      <JoinMovement />
      <Footer />
    </>
  );
};

export default Home;
